__turbopack_context__.v({
  "action": "checkout-module__ss_A1W__action",
  "back": "checkout-module__ss_A1W__back",
  "error": "checkout-module__ss_A1W__error",
  "heading": "checkout-module__ss_A1W__heading",
  "insurance": "checkout-module__ss_A1W__insurance",
  "item": "checkout-module__ss_A1W__item",
  "items": "checkout-module__ss_A1W__items",
  "label": "checkout-module__ss_A1W__label",
  "layout": "checkout-module__ss_A1W__layout",
  "mainColumn": "checkout-module__ss_A1W__mainColumn",
  "page": "checkout-module__ss_A1W__page",
  "panel": "checkout-module__ss_A1W__panel",
  "panelHeading": "checkout-module__ss_A1W__panelHeading",
  "paymentNote": "checkout-module__ss_A1W__paymentNote",
  "quote": "checkout-module__ss_A1W__quote",
  "quoteList": "checkout-module__ss_A1W__quoteList",
  "quoteSelected": "checkout-module__ss_A1W__quoteSelected",
  "quoteText": "checkout-module__ss_A1W__quoteText",
  "secondary": "checkout-module__ss_A1W__secondary",
  "summary": "checkout-module__ss_A1W__summary",
  "total": "checkout-module__ss_A1W__total",
});
